module.exports = __webpack_public_path__ + "img/tram-blue.8be57057.svg";